// extracted by mini-css-extract-plugin
export default {"default":"iv78aEHLLtsiUh8GFn4f","errorIcon":"M3VRB1336zjbib44PXU1","none":"P1lgtTGpEqvZOZN6jHhy","light":"s6ru3r79wwzCecEO0O_S Wq_kDyhaPS64oOwPIyD8","close":"UA79Yb8sgCzQ0x5wuvCQ"};